import { setDispatch } from "../../api/socket/"

export default function socketMiddleware(store) {
	setDispatch(store.dispatch)

	// Actual middleware implementation just passes all
	// actions through without touching them - Do not delete!
	return (next) => (action) => next(action)
}
